import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faHashtag } from '@fortawesome/free-solid-svg-icons';

function Contacts() {
  return (
    <div className='About_US_SULUHU'>
            <div className='cont_details'><FontAwesomeIcon icon={faPhone} /> +254 786675699</div>
            <div className='cont_details'><FontAwesomeIcon icon={faPhone} /> 0723 660 596</div>
            <div className='cont_details'><FontAwesomeIcon icon={faEnvelope} /><a href='https://suluhuproducts@gmail.com'>
               Email: suluhuproducts@gmail.com</a></div>

        
            <div className='cont_details'>
            Instagram: <a href='https://www.instagram.com/hos.teladventures?igsh=MWVtYzdsdmMyYTNjZw=='>@suluhu_products </a>
            </div>
        
         
    </div>
  )
}

export default Contacts